<template>
  <div>
    <v-row v-for="(payment, index) in payments" :key="getPaymentKey(payment, index)">
      <v-col cols="2">
        <user-avatar class="mt-2" :user="payment.user" />
      </v-col>
      <v-col cols="10">
        <payments-select
          :token="payment.token"
          :readonly="payment.readonly || false"
          @token-changed="onTokenChanged(index, $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PaymentList",
  props: {
    payments: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    getPaymentKey(payment, index) {
      // Use taskId if available, otherwise use task.id, otherwise fallback to index
      return payment.taskId || payment.task?.id || index;
    },
    onTokenChanged(index, value) {
      this.$emit('payment-changed', { index, value });
    }
  }
};
</script>
